/**
 * Generates and downloads the blank Excel template used by the Order Workbench
 * Upload Orders flow (Hot Orders + Ad-hoc Orders). Headers and order match the
 * structure the backend ImportVendorOrderType-equivalent SP expects — see the
 * Hot/Ad-hoc Orders sprint tickets for the per-field semantics.
 *
 * Pattern mirrors helper/exportAll.ts — Workbook (exceljs) and fs (file-saver)
 * are injected so this helper doesn't carry hard imports of those packages.
 */
export const downloadOrderUploadTemplate = (
  Workbook: any,
  fs: any
) => {
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('Order Upload');
  let columns = getColumnDefs();
  worksheet.columns = columns as any;
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'cccccc' },
  };
  workbook.xlsx.writeBuffer().then((data: any) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    fs.saveAs(blob, `OrderUploadTemplate_${new Date().toISOString()}.xlsx`);
  });
};

function getColumnDefs() {
  const headerStyle = {
    border: {
      top: { style: 'thin', color: { argb: '000000' } },
      left: { style: 'thin', color: { argb: '000000' } },
      bottom: { style: 'thin', color: { argb: '000000' } },
      right: { style: 'thin', color: { argb: '000000' } },
    },
    fill: {
      type: 'pattern',
      gradient: 'lightGray',
      bgColor: { argb: '808080' },
    },
  };

  const columns = [
    { header: 'Retailer',         key: 'retailer',         width: 15, style: headerStyle },
    { header: 'Order Batch ID',      key: 'orderBatchId',       width: 18, style: headerStyle },
    { header: 'Retailer Store ID',   key: 'retailerStoreId',    width: 18, style: headerStyle },
    { header: 'Product Code',        key: 'productId',          width: 15, style: headerStyle },
    { header: 'UPC',                 key: 'upc',                width: 18, style: headerStyle },
    { header: 'Vendor Product Code', key: 'sku',                width: 20, style: headerStyle },
    { header: 'Algo Change',         key: 'algoChange',         width: 15, style: headerStyle },
    { header: 'JB HiFi Change',      key: 'jbHiFiChange',       width: 16, style: headerStyle },
    { header: 'Supplier Adjustment', key: 'supplierAdjustment', width: 20, style: headerStyle },
    { header: 'Push Order',          key: 'pushOrder',          width: 15, style: headerStyle },
    { header: 'Change Type',         key: 'changeType',         width: 14, style: headerStyle },
    { header: 'Description',         key: 'description',        width: 30, style: headerStyle },
    { header: 'Ship Date',           key: 'shipDate',           width: 14, style: headerStyle },
    { header: 'Delivery Date',       key: 'deliveryDate',       width: 14, style: headerStyle },
    // { header: 'Supplier ID',         key: 'supplierId',         width: 15, style: headerStyle },
  ];
  return columns;
}